function CourseManager () {
    return (
        <div className="CourseManager">
            CourseManager
        </div>
    )
}

export default CourseManager;